export enum Sentiment {
  ACCENT = 'accent',
  BRAND = 'brand',
  DEFAULT = 'default',
  NOTIFY = 'notify',
  RISK = 'risk',
  ENGAGE = 'engage',
  WEAK = 'weak',
}
